import { presets } from "config/images";
import { PLACEHOLDER, ERROR } from "./ImageComponent";
import makeImgSrc from "./makeImageSrc";
import imageAdapters from "./adapters";

const makeImageSrcset = (
  baseUrl,
  src,
  format,
  sizes,
  bg,
  extension,
  cover,
  fluid,
  focalPoint
) => {
  if (src.startsWith("data:image")) {
    return src;
  }

  return sizes
    .map((size) => {
      const imageUrl = makeImgSrc(
        src,
        format,
        size,
        bg,
        extension,
        cover,
        baseUrl,
        focalPoint
      );
      const imageSet = fluid ? `${presets[format].width * size}w` : `${size}x`;
      return `${imageUrl} ${imageSet}`;
    })
    .join(", ");
};

const makeImgProps = (baseUrl, src, format, bg, cover, fluid, focalPoint) => {
  if (!presets[format]) {
    return {
      src: src,
      sources: [],
    };
  }

  const defaultSizes = [0.5, 1, 2, 4];
  const presetSizes = presets[format]?.sizes;
  const sizes = presetSizes?.length ? presetSizes : defaultSizes;
  const sourcesExtensions = imageAdapters.getSupportedExtensions(
    src,
    bg === "transparent"
  );
  const defaultExtension = imageAdapters.getDefaultExtension(src);

  return {
    src: makeImgSrc(
      src,
      format,
      sizes[0],
      bg,
      defaultExtension,
      cover,
      baseUrl,
      focalPoint
    ),
    sources: sourcesExtensions.map((extension) => ({
      ...(extension ? { type: `image/${extension}` } : {}),
      srcSet: makeImageSrcset(
        baseUrl,
        src,
        format,
        sizes,
        bg,
        extension,
        cover,
        fluid,
        focalPoint
      ),
    })),
  };
};

const makeImagesProps = (
  baseUrl,
  src,
  format,
  bg,
  cover,
  fluid,
  placeholderSrc = PLACEHOLDER,
  errorSrc = ERROR,
  focalPoint = undefined
) => {
  const loadingImagesProps = makeImgProps(
    baseUrl,
    placeholderSrc,
    format,
    bg,
    true,
    fluid,
    focalPoint
  );
  return {
    done: makeImgProps(baseUrl, src, format, bg, cover, fluid, focalPoint),
    loading: loadingImagesProps,
    lazy: loadingImagesProps,
    error: makeImgProps(baseUrl, errorSrc, format, bg, true, fluid, focalPoint),
  };
};

export default makeImagesProps;
